(function() {
    'use strict';
  
    function initFeatureCardsCarousel() {
      const sections = document.querySelectorAll('.mt-feature-cards2[data-section-id]');
      
      sections.forEach(function(section) {
        // 检查是否已经初始化过
        if (section.hasAttribute('data-carousel-initialized')) {
          return;
        }
  
        const track = section.querySelector('.mt-feature-cards__track2');
        if (!track) return;
        
        const wrapper = section.querySelector('.mt-feature-cards__wrapper2');
        if (!wrapper) return;
  
        let items = wrapper.querySelectorAll('.mt-feature-cards__item2');
        if (items.length === 0) return;
  
        // 只在移动端启用轮播
        const isMobile = window.innerWidth <= 750;
        if (!isMobile) {
          return;
        }
  
        const totalItems = items.length;
        if (totalItems <= 1) return;
  
        // 确保容器已经渲染，有宽度
        if (track.offsetWidth === 0) {
          // 如果容器还没有宽度，等待一下再初始化
          setTimeout(function() {
            initFeatureCardsCarousel();
          }, 50);
          return;
        }
  
        // 标记为已初始化，防止重复初始化
        section.setAttribute('data-carousel-initialized', 'true');
  
        // 获取倒计时秒数（0 或以下则视为关闭自动轮播）
        const autoplayIntervalAttr = parseInt(section.getAttribute('data-autoplay-interval'), 10);
        const autoplayInterval = isNaN(autoplayIntervalAttr) ? 3 : autoplayIntervalAttr;
        const isAutoplayEnabled = autoplayInterval > 0;
        const autoplayDuration = autoplayInterval * 1000; // 转换为毫秒
  
        // dot点数量 = 卡片数量（一次显示1张）
        const totalDots = totalItems;
  
        // 创建分页指示器
        let pagination = section.querySelector('.mt-feature-cards__pagination2');
        if (!pagination) {
          pagination = document.createElement('div');
          pagination.className = 'mt-feature-cards__pagination2';
          section.querySelector('.mt-feature-cards__container2').appendChild(pagination);
        } else {
          pagination.innerHTML = '';
        }
  
        // 创建带倒计时的分页点（数量为 totalItems - 1）
        const dots = [];
        for (let i = 0; i < totalDots; i++) {
          const dot = document.createElement('button');
          dot.className = 'mt-feature-cards__pagination-dot2';
          dot.setAttribute('data-index', i);
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          
          // 创建进度条
          const progress = document.createElement('div');
          progress.className = 'mt-feature-cards__pagination-progress2';
          dot.appendChild(progress);
          
          pagination.appendChild(dot);
          dots.push(dot);
        }
  
        let currentIndex = 0;
        let autoplayTimer = null;
        let progressTimer = null;
        let isPaused = false;
        let isDragging = false;
        let startX = 0;
        let startY = 0;
        let currentX = 0;
        let currentY = 0;
        let startTranslateX = 0;
        let translateX = 0;
        let isHorizontalSwipe = false; // 是否确认是横向滑动
        let swipeDirection = null; // 滑动方向：'horizontal' 或 'vertical'
  
        // 克隆首尾元素实现无限轮播
        // 克隆最后一张放在最前面（用于向左滑动时显示）
        const lastClone = items[totalItems - 1].cloneNode(true);
        lastClone.classList.add('mt-feature-cards__item--clone2');
        // 确保克隆元素有正确的样式
        lastClone.style.width = '';
        lastClone.style.display = '';
        wrapper.insertBefore(lastClone, items[0]);
        
        // 克隆第一张放在最后面（用于向右滑动时显示）
        const firstClone = items[0].cloneNode(true);
        firstClone.classList.add('mt-feature-cards__item--clone2');
        // 确保克隆元素有正确的样式
        firstClone.style.width = '';
        firstClone.style.display = '';
        wrapper.appendChild(firstClone);
  
        // 重新获取所有元素（包括克隆的）
        items = wrapper.querySelectorAll('.mt-feature-cards__item2');
        
        // 设置初始位置（显示第一张真实卡片）
        // 因为第一个是克隆的最后一张，所以从索引1开始（显示真实的第一张）
        currentIndex = 1;
        updateCarousel(false);
  
        // 更新轮播位置
        function updateCarousel(animate = true) {
          if (animate) {
            track.style.transition = 'transform 0.5s ease';
          } else {
            track.style.transition = 'none';
          }
  
          // 计算真实索引（用于显示正确的 dot）
          // currentIndex 从 1 开始（因为第一个是克隆的）
          // 一次显示2张，所以 realIndex = currentIndex - 1
          let realIndex = currentIndex - 1;
          if (realIndex < 0) realIndex = totalDots - 1;
          if (realIndex >= totalDots) realIndex = 0;
  
          // 一次移动1张
          // 使用实际的item元素宽度来计算，而不是视口宽度
          // 这样可以确保精确对齐
          const gap = 10; // gap 16px
          const viewportWidth = window.innerWidth;
          
          // 获取第一个真实item（非克隆）的实际宽度
          const firstRealItem = wrapper.querySelector('.mt-feature-cards__item2:not(.mt-feature-cards__item--clone2)');
          let itemWidth = 0;
          if (firstRealItem) {
            itemWidth = firstRealItem.getBoundingClientRect().width;
          } else {
            // 如果获取不到，使用计算值作为后备
            itemWidth = (viewportWidth - gap) / 2;
          }
          
          const moveDistance = itemWidth + gap; // 移动一张的距离（像素）
          translateX = -currentIndex * moveDistance; // 使用像素值
          track.style.transform = `translateX(${translateX}px)`;
  
          // 更新分页点状态
          dots.forEach(function(dot, index) {
            const progress = dot.querySelector('.mt-feature-cards__pagination-progress2');
            if (index === realIndex) {
              dot.classList.add('mt-feature-cards__pagination-dot--active2');
              if (progress) {
                progress.style.width = '0%';
                progress.style.transition = 'none'; // 清除过渡，确保可以重新开始动画
              }
            } else {
              dot.classList.remove('mt-feature-cards__pagination-dot--active2');
              if (progress) {
                progress.style.width = '0%';
                progress.style.transition = 'none'; // 清除过渡
              }
            }
          });
  
          // 处理无限循环
          setTimeout(function() {
            const gap = 16;
            const viewportWidth = window.innerWidth;
            if (viewportWidth === 0) return; // 防止视口宽度为0
            
            // 获取第一个真实item的实际宽度
            const firstRealItem = wrapper.querySelector('.mt-feature-cards__item2:not(.mt-feature-cards__item--clone2)');
            let itemWidth = 0;
            if (firstRealItem) {
              itemWidth = firstRealItem.getBoundingClientRect().width;
            } else {
              itemWidth = (viewportWidth - gap) / 2;
            }
            
            const moveDistance = itemWidth + gap;
            
            if (currentIndex === 0) {
              // 向左滑动到克隆的最后一张，跳转到真实的最后位置
              track.style.transition = 'none';
              currentIndex = totalDots;
              translateX = -currentIndex * moveDistance;
              track.style.transform = `translateX(${translateX}px)`;
            } else if (currentIndex > totalDots) {
              // 向右滑动到克隆的第一张，跳转到真实的第一位置
              track.style.transition = 'none';
              currentIndex = 1;
              translateX = -currentIndex * moveDistance;
              track.style.transform = `translateX(${translateX}px)`;
            }
          }, animate ? 500 : 0);
        }
  
        // 下一张
        function next() {
          currentIndex++;
          updateCarousel();
          startAutoplay();
        }
  
        // 上一张
        function prev() {
          currentIndex--;
          updateCarousel();
          startAutoplay();
        }
  
        // 开始自动播放
        function startAutoplay() {
          // 关闭自动轮播时，直接返回
          if (!isAutoplayEnabled) {
            return;
          }
          
          stopAutoplay();
          
          if (isPaused || isDragging) {
            return;
          }
  
          const realIndex = getRealIndex();
          const activeDot = dots[realIndex];
          const progress = activeDot ? activeDot.querySelector('.mt-feature-cards__pagination-progress2') : null;

          // 仅在开启自动轮播时执行进度动画
          if (progress && isAutoplayEnabled) {
            progress.style.width = '0%';
            progress.style.transition = 'none';
            // 强制重排
            void progress.offsetWidth;
            progress.style.transition = `width ${autoplayDuration}ms linear`;
            progress.style.width = '100%';
          }
  
          autoplayTimer = setTimeout(function() {
            next();
          }, autoplayDuration);
          
        }
  
        // 停止自动播放
        function stopAutoplay() {
          if (autoplayTimer) {
            clearTimeout(autoplayTimer);
            autoplayTimer = null;
          }
          dots.forEach(function(dot) {
            const progress = dot.querySelector('.mt-feature-cards__pagination-progress2');
            if (progress) {
              progress.style.width = '0%';
              progress.style.transition = 'none';
            }
          });
        }
  
        // 获取真实索引
        function getRealIndex() {
          let realIndex = currentIndex - 1;
          if (realIndex < 0) realIndex = totalDots - 1;
          if (realIndex >= totalDots) realIndex = 0;
          return realIndex;
        }
  
        // 触摸事件处理 - 添加方向识别和滚动冲突处理
        track.addEventListener('touchstart', function(e) {
          isDragging = true;
          isPaused = true;
          stopAutoplay();
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          startTranslateX = translateX;
          isHorizontalSwipe = false; // 重置方向判断
          swipeDirection = null;
          track.style.transition = 'none';
        }, { passive: true });
  
        track.addEventListener('touchmove', function(e) {
          if (!isDragging) return;
          
          currentX = e.touches[0].clientX;
          currentY = e.touches[0].clientY;
          
          const diffX = currentX - startX;
          const diffY = currentY - startY;
          const absX = Math.abs(diffX);
          const absY = Math.abs(diffY);
          
          // 方向检测：如果还没有确定方向，则根据移动距离判断
          if (!isHorizontalSwipe && swipeDirection === null) {
            // 需要移动至少 10px 才开始判断方向
            if (absX > 10 || absY > 10) {
              if (absX > absY) {
                // 横向滑动
                swipeDirection = 'horizontal';
                isHorizontalSwipe = true;
              } else {
                // 纵向滑动
                swipeDirection = 'vertical';
                isHorizontalSwipe = false;
              }
            }
          }
          
          // 如果是横向滑动，阻止默认滚动行为并更新轮播位置
          if (isHorizontalSwipe && swipeDirection === 'horizontal') {
            e.preventDefault(); // 阻止页面滚动
            translateX = startTranslateX + diffX;
            track.style.transform = `translateX(${translateX}px)`;
          }
          // 如果是纵向滑动，不阻止默认行为，允许页面滚动
        }, { passive: false }); // 改为 false，以便可以使用 preventDefault
  
        track.addEventListener('touchend', function(e) {
          if (!isDragging) return;
          
          const diffX = currentX - startX;
          const diffY = currentY - startY;
          const absX = Math.abs(diffX);
          const absY = Math.abs(diffY);
          
          // 只有在确认是横向滑动时才处理轮播切换
          if (isHorizontalSwipe && swipeDirection === 'horizontal') {
            isDragging = false;
            track.style.transition = 'transform 0.5s ease';
  
            const viewportWidth = window.innerWidth;
            const threshold = viewportWidth * 0.15; // 15% 的滑动阈值
  
            if (absX > threshold) {
              if (diffX > 0) {
                // 向右滑动，显示上一张
                prev();
              } else {
                // 向左滑动，显示下一张
                next();
              }
            } else {
              // 回弹到当前位置
              updateCarousel();
            }
  
            // 延迟恢复自动播放
            setTimeout(function() {
              isPaused = false;
              startAutoplay();
            }, 500);
          } else {
            // 纵向滑动或未确认方向，直接重置状态
            isDragging = false;
            isPaused = false;
            startAutoplay();
          }
          
          // 重置方向判断
          isHorizontalSwipe = false;
          swipeDirection = null;
        }, { passive: true });
  
        // 分页点点击事件
        dots.forEach(function(dot, index) {
          dot.addEventListener('click', function() {
            currentIndex = index + 1; // +1 因为第一个是克隆的
            updateCarousel();
            startAutoplay();
          });
        });
  
        // 鼠标进入暂停，离开继续
        track.addEventListener('mouseenter', function() {
          isPaused = true;
          stopAutoplay();
        });
  
        track.addEventListener('mouseleave', function() {
          isPaused = false;
          startAutoplay();
        });
  
        // 初始化自动播放
        // 使用 requestAnimationFrame 确保 DOM 完全渲染后再启动自动播放
        // 这样可以解决刷新后倒计时点不动的问题
        // 确保初始化时 isPaused 为 false（防止鼠标事件在初始化前触发导致暂停）
        isPaused = false;
        isDragging = false;
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            // 再次确保状态正确（防止在 requestAnimationFrame 期间被其他事件改变）
            isPaused = false;
            isDragging = false;
            startAutoplay();
          });
        });
  
        // 窗口大小改变时重新初始化
        let resizeTimer;
        const handleResize = function() {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function() {
            const isNowMobile = window.innerWidth <= 750;
            if (isNowMobile && isMobile) {
              // 仍然是移动端，重新初始化
              stopAutoplay();
              currentIndex = 1;
              updateCarousel(false);
              startAutoplay();
            } else if (!isNowMobile) {
              // 切换到PC端，停止轮播
              stopAutoplay();
              track.style.transform = '';
              track.style.transition = '';
            }
          }, 250);
        };
  
        window.addEventListener('resize', handleResize);
  
        // 页面可见性变化时暂停/继续
        document.addEventListener('visibilitychange', function() {
          if (document.hidden) {
            stopAutoplay();
          } else {
            startAutoplay();
          }
        });
      });
    }
  
    // 页面加载完成后初始化
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFeatureCardsCarousel);
    } else {
      initFeatureCardsCarousel();
    }
  
    // Shopify 主题编辑器支持
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(e) {
        // 清除初始化标记，允许重新初始化
        if (e.detail && e.detail.sectionId) {
          const section = document.querySelector(`.mt-feature-cards2[data-section-id="${e.detail.sectionId}"]`);
          if (section) {
            section.removeAttribute('data-carousel-initialized');
          }
        }
        setTimeout(initFeatureCardsCarousel, 100);
      });
      document.addEventListener('shopify:section:reorder', function() {
        // 清除所有初始化标记
        document.querySelectorAll('.mt-feature-cards2[data-carousel-initialized]').forEach(function(section) {
          section.removeAttribute('data-carousel-initialized');
        });
        setTimeout(initFeatureCardsCarousel, 100);
      });
    }
  })();
  
  